import Heading from '@components/Heading/Heading';
import styles from '@features/cms/components/pages/MultiIconBlock/MultiIconBlock.styles';
import { IMultiIconBlock } from '@features/cms/typescript';
import theme from '@styles/theme';
import IconSingle from '@features/cms/components/pages/MultiIconBlock/IconSingle/IconSingle';
import sanitizeHtml from '@utils/sanitizeHtml';
type PropsType = {
  data: IMultiIconBlock;
};
const MultiIconBlock = ({
  data
}: PropsType) => {
  const {
    code,
    marginTop,
    marginBottom,
    background,
    title,
    description,
    color,
    icons
  } = data;
  return <section id={code} sx={styles.section(background, marginTop, marginBottom)} data-testid={code}>
      <div data-testid="MultiIconBlock-container">
        <Heading headingType={2} pb={16} mobile color={color || theme.rawColors.neutralBlack}>
          {title}
        </Heading>
        <p className="description" sx={styles.description(color || theme.rawColors.neutralBlack)} dangerouslySetInnerHTML={sanitizeHtml(description)} />

        <div sx={styles.iconContainer(icons.length)} data-testid="MultiIconBlock-iconContainer">
          {icons.map(icon => <IconSingle key={icon.text} iconSingle={icon} color={color || theme.rawColors.neutralBlack} />)}
        </div>
      </div>
    </section>;
};
export default MultiIconBlock;